import { zodResolver } from "@hookform/resolvers/zod";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { useEffect, useState } from "react";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import { useUsers } from "../../hooks/useUsers";
import { useAppSelector, AppState } from "../../store";
import { clearToken } from "../../utils/clearToken";
import { useSnackbar } from "../../hooks/useSnackbar";
import { passwordChangeSchema } from "../../config/schemas/changePasswordSchema";
import PasswordRequirement from "../common/PasswordRequirement";

const style = {
  bgcolor: "background.paper",
  boxShadow: 24,
};

const SwitchRole = (props: any) => {
  type FormData = z.infer<typeof passwordChangeSchema>;
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      current_password: "",
      new_password: "",
      confirm_new_password: "",
    },
    resolver: zodResolver(passwordChangeSchema),
  });
  const userObj = useAppSelector(
    (state: AppState) => state.commonSlice.userObj
  );
  const { email } = userObj;
  const { changePassword, changePasswordError, changePasswordIsError } =
    useUsers();
  const { openChangePassword, setOpenChangePassword } = props;
  const [showPassword, setShowPassword] = useState(false);
  const [showCnfPassword, setShowCnfPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const { showSuccess, handleError } = useSnackbar();
  const onInvalid = (errors: any) => console.debug(errors);
  const submit = async (data: FormData) => {
    const res: any = await changePassword({
      data: {
        ...data,
        email,
      },
    });
    if (res?.data) {
      showSuccess(
        `Re-login with new password credentials`,
        "change-password-success"
      );
      setTimeout(() => {
        handleClose();
        window.location.replace("/login");
        clearToken();
      }, 1000);
    }
  };
  const handleClose = () => {
    setOpenChangePassword(false);
    reset();
  };

  useEffect(() => {
    if (changePasswordIsError) {
      const error: any = changePasswordError;
      handleError(error);
    }
  }, [changePasswordIsError]);
  return (
    <>
      <Modal
        open={openChangePassword}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modalFixes maxWidthsm"
      >
        <Box className="modal-style" sx={{ ...style }}>
          <Typography variant="h6">Change Password</Typography>
          <Box sx={{ mt: 1 }}>
            <form onSubmit={handleSubmit(submit, onInvalid)}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Current Password*"
                    autoComplete="off"
                    type={showPassword ? "text" : "password"}
                    variant="standard"
                    {...register("current_password")}
                    error={!!errors.current_password}
                    helperText={errors.current_password?.message as any}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword((show) => !show)}
                            onMouseDown={(event) => event.preventDefault()}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="New Password*"
                    type={showNewPassword ? "text" : "password"}
                    variant="standard"
                    {...register("new_password")}
                    error={!!errors.new_password}
                    helperText={errors.new_password?.message as any}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowNewPassword((show) => !show)}
                            onMouseDown={(event) => event.preventDefault()}
                            edge="end"
                          >
                            {showNewPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <PasswordRequirement />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Confirm New Password*"
                    type={showCnfPassword ? "text" : "password"}
                    variant="standard"
                    {...register("confirm_new_password")}
                    error={!!errors.confirm_new_password}
                    helperText={errors.confirm_new_password?.message as any}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowCnfPassword((show) => !show)}
                            onMouseDown={(event) => event.preventDefault()}
                            edge="end"
                          >
                            {showCnfPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <Box mt={4} sx={{ textAlign: "right" }}>
                <Button
                  className="grey-btn"
                  onClick={handleClose}
                  id="change_password_cancel"
                >
                  CANCEL
                </Button>
                <Button type="submit" autoFocus id="change_password_save">
                  Save
                </Button>
              </Box>
            </form>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default SwitchRole;
